// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["components/block/block","css/main.style"], function() { return __webpack_require__("./src/js/main.script.js"); })
__webpack_require__.O(undefined, ["components/block/block","css/main.style"], function() { return __webpack_require__("./src/scss/main.style.scss"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["components/block/block","css/main.style"], function() { return __webpack_require__("./src/components/block/block.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
